var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 50,
    viewBox: "0 0 17 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3055 8.11236C16.3055 12.5925 12.6729 16.2247 8.19246 16.2247C3.71199 16.2247 0.0794678 12.5925 0.0794678 8.11236C0.0794678 3.63224 3.71199 0 8.19246 0C12.6729 0 16.3055 3.63224 16.3055 8.11236Z",
    fill: "#FF6AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.045 49.6687C16.045 49.8501 15.895 50.0002 15.7135 50.0002H0.325028C0.143576 50.0002 -0.00646973 49.8501 -0.00646973 49.6687V20.3246C-0.00646973 20.1432 0.143576 19.9932 0.325028 19.9932H15.7135C15.895 19.9932 16.045 20.1432 16.045 20.3246V49.6687Z",
    fill: "#FF6AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/_16.a15058aca9b6e33034bb9a7c216321ce.svg";
export { ForwardRef as ReactComponent };